import AllChats from '../components/ChatThreadList/AllChats';
import Header from '../components/Header';

const Conversations = () => (
    <div className='flex flex-col min-h-full'>
        <Header navTitle='Conversations' />
        <div className='grow flex flex-col px-20 py-20 gap-15 h-full'>
            <AllChats />
        </div>
    </div>
);

export default Conversations;
